import { ComponentType, useEffect, useState } from 'react';
import { Country } from '../../api';
import dispatchEvent from '../utils/dispatchEvent';
import { makeCountryOptions } from '../utils/makeOptions';
import { Option, SelectChangeEvent, HOCSelectProps } from './types';

interface CountrySelectWrapperProps extends HOCSelectProps {
  Component: ComponentType<any>;
  countries: Country[];
  loading: boolean;
  error: Error | undefined;
}

const CountrySelectWrapper = ({
  onError, onLoading, onChange, defaultCountry, countries, loading, error, value, Component, ...rest
}: CountrySelectWrapperProps) => {
  const [options, setOptions] = useState<Option[]>([]);
  const [selectedValue, setSelectedValue] = useState<string>(value || '');

  useEffect(() => {
    // needs to set initial value once, if value is not provided
    if (options.length > 0 && selectedValue.length === 0) {
      onChange?.({ target: { value: defaultCountry || options[0].value } });
      dispatchEvent('mist-com-country-selected', { countryCode: defaultCountry || options[0].value });
      setSelectedValue(defaultCountry || options[0].value);
    }
  }, [options, onChange, defaultCountry, selectedValue]);

  useEffect(() => {
    if (countries.length > 0) {
      setOptions(makeCountryOptions(countries || []));
    }
  }, [countries]);

  useEffect(() => onLoading?.(loading), [loading, onLoading]);
  useEffect(() => onError?.(error), [error, onError]);

  const handleChange = (e: SelectChangeEvent<string>) => {
    const { value } = e.target;
    setSelectedValue(value);
    dispatchEvent('mist-com-country-selected', { countryCode: value });
    onChange?.({ target: { value: value } });
  };

  return <Component {...rest}
    onChange={handleChange}
    // Hack for ecom selects, if options is empty array it crashes
    options={!options || options.length === 0 ? [{ label: '', value: '' }] : options}
    value={selectedValue}
  />;
}

export default CountrySelectWrapper;
